import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools, Time } from '../../../services'

import Switch from 'react-switch'
import { Headerbar, FormInput, ConfirmLink, ClickToCopy, Loader, EditContainer, ImagesPicker, Select } from '../../Reusable'

import FadeIn from 'react-fade-in';

import TicketingTickets from '../../Ticketing/TicketingTickets'
import TicketingPromos from '../../Ticketing/TicketingPromos'
import TicketingOrders from '../../Ticketing/TicketingOrders'

import EventForm from './EventForm'
import PlaceForm from './PlaceForm'
import DiscountForm from './DiscountForm'
import AdValidator from './AdValidator'

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const AdScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)
  const proId = props.match.params.proId
  const elementId = props.match.params.id
  const elementRef = Fire.collection('ads').doc(elementId)
  const type = props.match.params.type
  const tab = props.match.params.tab

  const [pro, setPro] = React.useState<any>(proId ? {} : user)
  const [pros, setPros] = React.useState<any[]>([])
  const [tickets, setTickets] = React.useState<any[]>([])
  const [ticketsLoading, setTicketsLoading] = React.useState(false)

  const fetchPros = async () => {
    try {
      const list = await Fire.list(Fire.collection('pros'))
      setPros(list)
    } catch (err) {
      console.warn(err)
    }
  }

  React.useEffect(() => {
    fetchPros()
  }, [])

  const fetchTickets = async () => {
    setTicketsLoading(true)
    try {
      const list = await Fire.list(elementRef.collection('tickets'))
      setTickets(list)
    } catch (err) {
      console.warn(err)
    }
    setTicketsLoading(false)
  }

  const onFetch = async (id: string) => {
    try {
      const element = await Fire.doc(elementRef)
      if (!element) {
        setError("L'annonce n'est plus accessible")
        return null
      }

      if (proId) {
        const pro = await Fire.doc(Fire.collection('pros').doc(proId))
        if (!pro) {
          setError("Le professionel n'existe plus")
          return null
        }
        setPro(pro)
      }

      await fetchTickets()

      element.pictures = Tools.formatPictures(element.pictures)

      if (element.dateStart)
        element.dateStart = Fire.getDateFor(element.dateStart)
       
      if (element.dateEnd)
        element.dateEnd = Fire.getDateFor(element.dateEnd)

      return element
    } catch (err) {
      setError("Impossible de charger l'annonce")
      console.warn(err)
    }
    return null
  }

  const onSave = async (item: any, { setItem }) => {
    const data = {
      ...item
    }

    try {
      if (item.id) {
        data.pictures = await Tools.uploadPictures('ads/' + item.id, item.pictures)
        
        if (item.proId) {
          const proRef = Fire.collection('pros').doc(item.proId)
          const loadedPro = await Fire.doc(proRef)
          data.pro = { name: loadedPro.name || 'Inconnu' }
          
          if (user.admin && !item.pro) {
            await proRef.update({
              total_impressions: Fire.increment(item.impressions_count),
              total_impressions_reach: Fire.increment(item.impressions_count_reach),
              total_views: Fire.increment(item.views_count),
              total_views_reach: Fire.increment(item.views_count_reach),
              total_clicks: Fire.increment(item.clicks_count),
              total_clicks_reach: Fire.increment(item.clicks_count_reach),
            })
          }
        }

        await Fire.store().collection('ads').doc(item.id).update(data)
        history.push('/ads/' + type + '/' + item.id + '/recap')
      }
      else {
        const newItem = Fire.store().collection('ads').doc()
        data.createdAt = new Date()
        data.pictures = await Tools.uploadPictures('ads/' + newItem.id, item.pictures)

        if (user.admin) {
          if (proId) {
            data.proId = proId
            data.pro = { name: pro.name || 'Inconnu' }
          }
          data.creatorId = user.id
          data.creator = { name: user.name || 'Pop Out' }
        } else {
          data.proId = user.id
          data.pro = { name: user.name || 'Pop Out' }
        }

        await newItem.set(data)
        history.push('/ads/' + type + '/' + newItem.id + '/recap')
      }
    } catch (err) {
      setError("Impossible de modifier l'annonce")
      console.warn(err)
    }
  }

  const duplicate = async ({ item }) => {
    const newEvent = Fire.store().collection('ads').doc()

    const payload: any = {
      ...item,
      id: newEvent.id,
      published: false,
      soldOut: false,
      createdAt: new Date(),
    }

    await newEvent.set(payload)
    history.push('/app/' + type)
  }

  const onRemove = async (item: any) => {
    try {
      await Fire.store().collection('ads').doc(item.id).delete()
      history.push('/app/' + type)
    } catch (err) {
      setError("Impossible de supprimer l'annonce")
      console.warn(err)
    }
  }

  const soldOut = async (soldOut: boolean, { setSaving, item, setItem }) => {
    const word = soldOut ? 'stopper les ventes' : 'reprendre les ventes'
    const confirm = window.confirm("Êtes-vous sûr de vouloir " + word + " ?")
    if (!confirm)
      return;

    setSaving(true)
    try {
      await Fire.store().collection('ads').doc(item.id).update({ soldOut: soldOut })
      setItem({ ...item, soldOut: soldOut })
    } catch (err) {
      console.warn(err)
    }
    setSaving(false)
  }

  const publish = async (publish: boolean, { setSaving, item, setItem }) => {
    const word = publish ? 'publier' : 'cacher'
    const confirm = window.confirm("Êtes-vous sûr de vouloir " + word + " votre annonce maintenant ?")
    if (!confirm)
      return;
      
    setSaving(true)
    try {
      await Fire.store().collection('ads').doc(item.id).update({ published: publish })
      setItem({ ...item, published: publish })
    } catch (err) {
      console.warn(err)
    }
    setSaving(false)
  }

  const renderContent = (tools) => {
    const tab = tools.tab
    if (!tools.item.id || tab === 'info')
      return renderInfo(tools)
    if (tab === 'recap')
      return renderRecap(tools)
    if (tab === 'tickets')
      return renderTickets(tools)
    if (tab === 'promos')
      return renderPromos(tools)
    if (tab === 'orders')
      return renderOrders(tools)
    return (null)
  }

  const renderTickets = ({ item }) => {
    return (
      <TicketingTickets pro={pro} element={item} />
    )
  }
  const renderPromos = ({ item }) => {
    return (
      <TicketingPromos element={item} />
    )
  }
  const renderOrders = ({ item }) => {
    return (
      <TicketingOrders element={item} />
    )
  }

  const checkAccount = (item: any) => {
    return Object.keys(AdValidator.getAccountErrors(item, pro, tickets)).length === 0
  }
  const checkInfo = (item: any) => {
    return Object.keys(AdValidator.getInfoErrors(item)).length === 0
  }
  const checkTickets = (item: any) => {
    return Object.keys(AdValidator.getTicketsErrors(item, pro, tickets)).length === 0
  }

  const toStringList = (errors: any) => {
    const keys = Object.keys(errors)
    const list: any[] = []
    for (const key of keys) {
      const str = errors[key].trim()
      if (str.length)
        list.push(errors[key])
    }
    return list
  }

  const getErrorsList = (item: any) => {
    let list: any = []
    const infoErrors = AdValidator.getInfoErrors(item)
    const ticketsErrors = AdValidator.getTicketsErrors(item, pro, tickets)
    const accountErrors = AdValidator.getAccountErrors(item, pro, tickets)
    return list
      .concat(toStringList(infoErrors))
      .concat(toStringList(ticketsErrors))
      .concat(toStringList(accountErrors))
  }
   
  const canPublish = (item: any) => {
    return checkAccount(item) && checkInfo(item) && checkTickets(item)
  }
    
  const renderRecap = (tools: any) => {
    const {item, saving } = tools

    const publishable = canPublish(item)
    const errorsList = getErrorsList(item)
    return (
      <React.Fragment>
        
        <div className="row">
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-eye"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Impressions</span>
              <span className="info-box-number">{item.impressions_count || 0}</span>
            </div>
          </div>
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-street-view"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Reach</span>
              <span className="info-box-number">{item.impressions_count_reach || 0}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-hand-pointer"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Clics</span>
              <span className="info-box-number">{item.views_count || 0}</span>
            </div>
          </div>
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-link"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Clics {type == 'discount' ? 'lien' : 'billeterie'}</span>
              <span className="info-box-number">{item.clicks_count || 0}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-heart"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Favoris</span>
              <span className="info-box-number">{item.favorites_count || 0}</span>
            </div>
          </div>
          <div className="info-box col-sm">
            <span className="info-box-icon bg-success"><i className="fa fa-share-alt"></i></span>

            <div className="info-box-content">
              <span className="info-box-text">Partages</span>
              <span className="info-box-number">{item.shares_count || 0}</span>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <div className="row spaced-row">
              <h3 className="card-title">Statut de l'annonce</h3>
              { item.published ? (
                <span className="text-success" style={{cursor:'auto'}}>Visible <i style={{marginLeft: 3}} className="fa fa-check"></i></span>
              ) : (
                <span className="text-warning">Caché <i style={{marginLeft: 3}} className="fa fa-eye-slash"></i></span> 
              )}
            </div>
          </div>
          <div className="card-body">
            { errorsList.length ? (
              <div style={{marginBottom: 30}}>
                Points à corriger afin de publier votre annonce<br />
                {errorsList.map((item, index) => (
                  <div className="text-danger" key={index}>- {item}</div>
                ))}
              </div>
            ) : (null) }

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => publish(!item.published, tools)}
                disabled={saving || (!item.published && !publishable)}
                >
                { item.published ? 'Cacher mon annonce' : 'Publier mon annonce'}
              </button>

              { item.published &&
                <div style={{marginTop: 6}}>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => soldOut(!item.soldOut, tools)}
                    disabled={saving}
                    >
                    { !item.soldOut ? 'Sold out!' :  'Reprise des ventes' }
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  const renderInfo = (tools: any) => {
    const {item, onChange, remove} = tools
    let form: any = null
    switch (type) {
      case "event":
        form = <EventForm tools={tools} />
        break;
      
      case "place":
        form = <PlaceForm tools={tools} />
        break;

      case "discount":
        form = <DiscountForm tools={tools} />
        break;

      default:
        form = <div>Type de compte inconnu</div>
        break;
    }

    return (
      <React.Fragment>
        <ImagesPicker
          pictures={item.pictures}
          onChange={(pics: any) => onChange('pictures', pics)}
          />

        {form}

        { item.id !== undefined &&
          <div className="centered">
            <ConfirmLink
              title="Dupliquer l'annonce"
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir dupliquer cette annonce ?'
              onPress={() => duplicate(tools)}
              />

            <ConfirmLink
              title='Supprimer'
              className='btn-remove'
              confirmTitle='Êtes-vous sûr de vouloir supprimer cette annonce ?'
              onPress={remove}
              />
          </div>
        }
      </React.Fragment>
    )
  }

  const onSwitchTab = (tab, { changed, reset }) => {
    if (changed) {
      const confirm = window.confirm('Êtes-vous sûr de vouloir annuler vos modifications sans sauvegarder ?')
      if (!confirm)
        return;
      reset()
    }
    if (user.admin) {
      if (proId) {
        history.push('/ads/' + type + '/' + elementId + '/' + tab.key + '/' + proId)
      } else {
        history.push('/ads/' + type + '/' + elementId + '/' + tab.key)
      }
    } else {
      history.push('/ads/' + type + '/' + elementId + '/' + tab.key)
    } 
  }

  const onBack = () => {
    if (user.admin) {
      if (proId) {
        history.push('/admin/pro/' + proId + '/' + type + 's')
      } else {
        history.push('/app/' + type)
      }
    } else {
      history.push('/app/' + type)
    } 
  }

  return (
    <EditContainer
      id={elementId}
      error={error}

      onBack={onBack}
      renderTabs={(item) => {
        const start: any[] = [
          {
            title: 'Récap',
            key: 'recap',
            status: item.published ? 'success' : 'off'
          },
          {
            title: 'Infos',
            key: 'info',
            status: checkInfo(item) ? 'success' : 'danger',
          },
        ]
        if (item.type !== 'discount' && item.hasTicketing) {
          start.push({
            title: 'Tickets',
            key: 'tickets',
            status: ticketsLoading ? 'off' : checkTickets(item) ? 'success' : 'danger',
          })
          if (user.admin) {
            start.push({
              title: 'Promos',
              key: 'promos',
            })
          }
          start.push({
            title: 'Commandes',
            key: 'orders',
          })
        }

        const end: any[] = [

        ] 

        return {
          currentTab: tab,
          defaultTab: 'recap',
          tabs: start.concat(end),
          onSwitchTab: onSwitchTab,
        }
      }}

      defaultCreationValue={{
        type: type,
        hasTicketing: type !== 'discount' ? true : false,
        inApp: true
      }}

      onFetch={onFetch}
      //onChange={onChange}
      onSave={onSave}
      onRemove={onRemove}
      renderContent={renderContent}
      />
  );
}

export default withRouter(AdScreen)
